<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-img
          contain
          lazy-src="/images/logo/jaqueSAI-logo.jpg"
          src="/images/logo/jaqueSAI-logo.jpg"
          max-height="1000"
        ></v-img>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import API from "@/api";
import EChart from "@/components/chart/echart";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import sistemaService from "@/services/sistemaService";

export default {
  components: {
    VWidget,
    MiniStatistic,
    EChart,
    CircleStatistic,
  },
  data: () => ({
    color: Material,
    selectedTab: "tab-1",
    linearTrending: [
      {
        subheading: "Sales",
        headline: "2,55",
        caption: "increase",
        percent: 15,
        icon: {
          label: "trending_up",
          color: "success",
        },
        linear: {
          value: 15,
          color: "success",
        },
      },
      {
        subheading: "Revenue",
        headline: "6,553",
        caption: "increase",
        percent: 10,
        icon: {
          label: "trending_down",
          color: "error",
        },
        linear: {
          value: 15,
          color: "error",
        },
      },
      {
        subheading: "Orders",
        headline: "5,00",
        caption: "increase",
        percent: 50,
        icon: {
          label: "arrow_upward",
          color: "info",
        },
        linear: {
          value: 50,
          color: "info",
        },
      },
    ],
    trending: [
      {
        subheading: "RENTAS",
        headline: "15",
        caption: " Rentas Vigentes",
        percent: 15,
        icon: {
          label: "style",
          color: "info",
        },
        linear: {
          value: 15,
          color: "info",
        },
      },
      {
        subheading: "VENTAS DEL MES",
        headline: "90",
        caption: " Ventas realizadas.",
        percent: 90,
        icon: {
          label: "list",
          color: "primary",
        },
        linear: {
          value: 90,
          color: "success",
        },
      },
      {
        subheading: "CUENTAS POR COBRAR",
        headline: "6",
        caption: "",
        percent: 6,
        icon: {
          label: "attach_money",
          color: "primary",
        },
        linear: {
          value: 6,
          color: "error",
        },
      },
    ],
  }),
  computed: {
    activity() {
      return API.getActivity();
    },
    posts() {
      return API.getPost(3);
    },
    siteTrafficData() {
      return API.getMonthVisit;
    },
    locationData() {
      return API.getLocation;
    },
  },
  mounted() {
   
    sistemaService.getVersion().then((result) => {
      this.$store.state.version = result;
    });
  },
  methods: {
    
  },
};
</script>
